
import { DataDefinition, DataDefinitionList } from '../../../admin360/data-definition/data-definition.model';

   export class CSTField {
      ID: number;
      ObjectID: number;
      FieldName: string;
      DisplayName: string;
      ExternalControlDataID: number;
      Description: string;
      DynamicPagesDataFiledsID: number;
      DynamicPagesDataFieldName: string;
      IsSysGen: boolean;
      FieldLength: number;
      StartRange: number;
      EndRange: number;
      DecimalPrecision: number;
      IsRequired: boolean;
      IsDataDef: boolean;
      LookupENUM: string;
      DataTypeID: number;
      ControlTypeID: number;
      ReadOnly: boolean;
      Active = true;
      IsFieldTracked: boolean;
      RequireNoGaps: boolean;
      AllowMultipleSelections: boolean;
      HeightInRows: number;
      IsSecured = false;
      PermissionCategory: string;
      AddedOn: Date;
      AddedBy: number;
      LastUpdatedOn: Date;
      LastUpdatedBy: number;
      DelStatus: boolean;
      ExternalDataDescription: string;
      ReadSPName: string;
      WriteSPName: string;
      ValueColumnName: string;
      DisplayColumnName: string;
      ParentFieldID: number;
      UsedForStateReporting: boolean;
      DataDef: DataDefinitionList;
      TextFormat: string;
      Value: string;
      IsProcedureBased: boolean;
      MasterId: number;
      ViewPermissionGroupIDs: number[];
      ModifyPermissionGroupIDS: number[];
      StateReportingFieldMetaDataID: number;
      UseDataDefCode: boolean;

      // client properties
      PageIndex: number;
   }

   export class CustomFieldDataObject {
      CustomFieldID: number;
      MasterId: number;
      SiteYearId: number;
      Value: string;
      ObjectID: number;
      UserCanEdit: boolean;
      IsDirty: boolean;
   }